<script setup lang="ts">

import { useMessageHandler } from '@/helpers/error/useMessageHandler';
import { useMessage } from 'naive-ui';

const errorMessage = useMessage();
const errorMessageHandler = useMessageHandler();
errorMessageHandler.errorMessage = errorMessage;

</script>

<template>

</template>

<style scoped lang="scss">

</style>